import ApiService from '../index'

// const qs = require('qs')

export const accountabilityData = async (payload) => {
  const URIDocumentation = '/api/accountability_report'

  const response = await ApiService.post(URIDocumentation, payload)

  return response.data
}

export const reportsDocs = async (payload) => {
  const URIReports = '/api/reports_docs'

  const response = await ApiService.post(URIReports, payload)

  return response.data
}
